export default __webpack_public_path__ + "static/media/charge.0708263e.webp";